<template>
    <div>
        <fieldset>
            <h3>Users</h3>
            <p class="headline"></p>
            <form-autocomplete multiple="false" :service="userService" :callback="addUserACL" icon="icon-icon_person"></form-autocomplete>
            <div class="listing-authorization" v-if="internalValue">
                <div class="authorization" v-for="(item, index) in internalValue" v-if="item.type == 'user'">
                    <div><span>{{ item.name }}</span></div>
                    <ul v-if="policyMethods">
                        <li v-for="(method, key) in policyMethods">
                            <label>{{ method.replace(/([A-Z])/g, ' $1').trim() }}</label>
                            <acl v-model="item.authorizations[method]"></acl>
                        </li>
                    </ul>
                    <button class="bt-remove" @click="removeACL(index,'user')"><i class="icon icon-icon_delete"></i></button>
                </div>
            </div>
        </fieldset>
        <fieldset>
            <h3>Roles</h3>
            <p class="headline"></p>
            <form-autocomplete multiple="false" :service="roleService" :callback="addRoleACL" icon="icon-icon_person"></form-autocomplete>
            <div class="listing-authorization">
                <div class="authorization" v-for="(item, index) in internalValue" v-if="item.type == 'role'">
                    <div><span>{{ item.name }}</span></div>
                    <ul v-if="policyMethods">
                        <li v-for="(method, key) in policyMethods">
                            <label>{{ method.replace(/([A-Z])/g, ' $1').trim() }}</label>
                            <acl v-model="item.authorizations[method]"></acl>
                        </li>
                    </ul>
                    <button class="bt-remove" @click="removeACL(index,'role')"><i class="icon icon-icon_delete"></i></button>
                </div>
            </div>
        </fieldset>
    </div>
</template>
<script>
    import UserService from "../modules/scope/UserService";
    import RoleService from "../modules/scope/RoleService";
    import AclModelService from '../modules/config/authorizations/AclModelService.js';

    export default {
        name: 'ACL Authorizations',
        props: ['value', 'model', 'type'],
        data: function () {
            return {
                modelSelected: null,
                permissions: null,
                policyMethods: null,
                internalValue: []
            }
        },
        created: function() {
            this.type = this.type ? this.type : 'global';
            this.userService = UserService;
            this.roleService = RoleService;
            this.internalValue = this.value;
            this.modelSelected = this.model;
            this.initializeModel();
        },
        mounted() {

        },
        methods: {
            initializeModel: function(){
                if( this.model ) {

                    if(this.type == 'global') {
                        AclModelService.getPermissionsByModel( this.model ).then( response => {
                            this.permissions = response.data;
                            this.policyMethods = response.data.methods;
                        });
                    }else{
                        AclModelService.getPermissionsByEntityModel( this.model ).then( response => {
                            this.permissions = response.data;
                            this.policyMethods = response.data.methods;
                        });
                    }

                }else{
                    AclModelService.getAllPermissions().then( response => {
                        this.permissions = response.data;
                    });
                }
            },
            addUserACL: function(item){
                if(item) { this.addAcl(item, 'user'); }
            },
            addRoleACL: function(item){
                if(item) { this.addAcl(item, 'role'); }
            },
            addAcl: function(item,type){
                let exists = false;
                this.internalValue.forEach(function(element){
                    if(element['id'] == item.id && element['type'] == type) {
                        exists = true;
                        return false;
                    }
                });
                if(exists == false) {
                    this.internalValue.push({
                        id: item.id,
                        type: type,
                        name: item.name,
                        authorizations: {}
                    });
                }else{
                    alert(type+' already selected');
                }
            },
            removeACL: function(n, type){
                this.internalValue.splice(n, 1);
                this.$forceUpdate;
            }
        },
        watch: {
            'model'(newVal, oldVal) {
                this.internalValue = [];
                this.policyMethods = null;
                this.modelSelected = newVal;
                this.initializeModel();
            },
            'value'(newVal, oldVal) {
                this.internalValue = newVal
            },
            'internalValue'(newVal, oldVal) {
                this.$emit('input', this.internalValue);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/AclAuthorizations.vue